module.exports = "/images/assetC1.png?2f490649fcc7e442c78593f1a3ecba8b";